export class Emitter {
    private events: { [key: string]: Array<(...args: any[]) => void> } = {};

    // Subscribe to an event
    on(event: string, listener: (...args: any[]) => void) {
        if (!this.events[event]) {
            this.events[event] = [];
        }
        this.events[event].push(listener);
    }

    // Unsubscribe from an event
    off(event: string, listener: (...args: any[]) => void) {
        if (!this.events[event]) return;

        this.events[event] = this.events[event].filter(l => l !== listener);
    }

    // Emit an event
    emit(event: string, ...args: any[]) {
        if (!this.events[event]) return;

        this.events[event].forEach(listener => {
            listener(...args);
        });
    }
}